import { styled, Typography } from "@mui/material";
import { useDialog } from "context/Dialog";
import useRole from "state/useRole";
import { useTranslation } from "react-i18next";

import QrcodeLine from "assets/image/qrcode_line.png";
import { Call, Email } from "@mui/icons-material";
import { EMAIL_CONTACT, TELE_NUMBER, TELE_NUMBER_VI } from "utility/constants";
import ContactIcon from "assets/image/contact.png";

const Contact = styled(`div`)`
  color: ${({ theme }) => theme.palette.text.primary} !important;
  text-align: center;
`;
const WrapperContact = styled(`div`)`
  display: flex;
  align-items: center;
  justify-content: center;
`;
type handleContactProps = {
  title?: string;
  [x: string]: any;
};

const useContact = () => {
  const { t } = useTranslation();
  const { getDialog } = useDialog();
  const { country } = useRole();
  const handleContact = (props?: handleContactProps) => {
    switch (country) {
      case "vi":
        getDialog({
          type: "info",
          description: (
            <Contact>
              <WrapperContact>
                <Call color="primary" />
                &nbsp; {TELE_NUMBER_VI}
              </WrapperContact>
              <WrapperContact>
                <Email color="primary" />
                &nbsp; &nbsp;
                {EMAIL_CONTACT}
              </WrapperContact>
            </Contact>
          ),
          variant: "standard",
          img: ContactIcon,
          title: props?.title || t("appbar.contact"),
        });
        break;
      default:
        getDialog({
          type: "info",
          description: (
            <Contact>
              <Typography variant="body2" color="text.secondary">
                {t("scan qrcode or contact")}
              </Typography>
              <WrapperContact>
                <Call color="primary" />
                &nbsp; {TELE_NUMBER}
              </WrapperContact>
              <WrapperContact>
                <Email color="primary" />
                &nbsp; &nbsp;
                {EMAIL_CONTACT}
              </WrapperContact>
            </Contact>
          ),
          variant: "standard",
          img: QrcodeLine,
          title: props?.title || t("appbar.contact"),
        });
        break;
    }
  };
  return {
    handleContact,
  };
};

export default useContact;
